import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5be45370"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-number"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "number" }, "01", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["innerHTML"]

import { ref, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-page-number-5',
  props: {
    isDetail: { type: Boolean, default: false },
    pageNo: { default: '01' }
  },
  setup(__props: any) {

const props = __props;

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1023 45">
    <g id="yema5" transform="translate(-1 -12)">
      <g id="组_4655" data-name="组 4655" transform="translate(-83 -1223)">
        <text id="_01" data-name="01" transform="translate(574.55 1269)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
        <rect id="矩形_2885" data-name="矩形 2885" width="462" height="1" transform="translate(645 1257)" fill="var(--theme-color-1)"/>
        <rect id="矩形_2889" data-name="矩形 2889" width="462" height="1" transform="translate(84 1257)" fill="var(--theme-color-1)"/>
      </g>
    </g>
  </svg>
`);

return (_ctx: any,_cache: any) => {
  return (_ctx.isDetail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "svg-block",
        innerHTML: svg.value
      }, null, 8, _hoisted_4))
}
}

})